import React, { useEffect } from 'react';
import MainRouter from './routers/MainRouter';
import { useMsal } from '@azure/msal-react';


/**
 * App component, the main component of the application
 * it contains the main router of the application, where routes or other routers can be included
 * 
 * @returns {JSX.Element} App component
 */
function App() {

  const {instance} = useMsal();

  /**
   * check if there is an account in the cache
   * if there is an account, set it as the active account
   */
  useEffect(() => {
    if(instance.getActiveAccount() !== null) {
      return;
    }
    const account = instance.getAllAccounts()[0];
    if (account) {
      instance.setActiveAccount(account);
    }
  }, [instance]);

  return (
    <>
      <MainRouter />
    </>
  );
}

export default App;
